<ng-container>
  <div class="post post-modern post-height">
    <div class="blog-boxes">
      <div class="post-img-wrap">
        <div *ngIf="buildImageSrc('image') | async | dotCmsCodecEncode as imageSrc">
          <a [routerLink]="'/page/blog/post/' + contentlet?.urlTitle">
            <ng-container *ngIf="imageSrc !== 'null'; else altenateImage">
              <img [src]="imageSrc" alt="Image not found" />
            </ng-container>
          </a>
        </div>
        <ng-template #altenateImage>
          <img [src]="'/assets/img/image-not-found.jpg'" alt="Image not found" />
        </ng-template>
      </div>
      <div class="position-relative blog-container">
        <div class="font-weigth-bold d-flex justify-content-center tag-container position-absolute">
          <div class="tag-title" *ngFor="let tag of getTags(contentlet?.tags)">{{ tag }}</div>
        </div>
        <div class="post-heading">
          <!--TODO SetAttributes blogPost title and teaser-->
          <h3 class="font-bold text-xl mb-4 line-clamp">
            <a [routerLink]="'/page/blog/post/' + contentlet?.urlTitle">{{ contentlet?.title }}</a>
          </h3>
          <ng-container *ngIf="isInSideEditor; else isNotInSideEditor">
            <p class="mb-2 text-6xl font-bold text-shadow">
              <ng-container *ngIf="!isInCarousel; else notEditable">
                <custom-dot-editable-text
                  fieldName="teaser"
                  [mode]="'minimal'"
                  [format]="'html'"
                  [contentlet]="contentlet"
                />
              </ng-container>
              <ng-template #notEditable>
                {{ contentlet.teaser }}
              </ng-template>
            </p>
          </ng-container>
          <ng-template #isNotInSideEditor>
            <div class="content-container">
              <div class="content" [ngClass]="{ expanded: isExpanded }">
                <p class="mb-2 text-6xl font-bold text-shadow" [ishServerHtml]="contentlet?.teaser"></p>
                <span *ngIf="shouldShowReadMore && !isExpanded" class="three-dot-line">...</span>

                <a href="#" *ngIf="shouldShowReadMore && !isExpanded" (click)="toggleContent($event)" class="read-more"
                  >Read More</a
                >
                <a href="#" *ngIf="shouldShowReadMore && isExpanded" (click)="toggleContent($event)" class="show-less"
                  >Show Less</a
                >
              </div>
            </div>
          </ng-template>
        </div>
        <div class="d-flex author-details">
          <div class="post-author">
            <ng-container *ngFor="let blogAuthor of contentlet?.author">
              <custom-dot-cms-blog-author
                [identifier]="blogAuthor.identifier"
                isBlog="blogAuthor"
              ></custom-dot-cms-blog-author>
            </ng-container>
          </div>
          <div class="text-gray-600">
            <span class="post-date md-start"
              ><i class="icon-clock"></i>
              {{ contentlet?.postingDate | date : 'medium' }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
